import { fetchFromServer, syncDependency, type DependencySyncConfig } from "./dependency-sync";
import { industrySectors } from "@/plugins/LocalForagePlugin";
import { industrySectorsSyncKey } from "@/types/products/product-keys";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";
import type { IndustrySectorApiResponse, IndustrySectors } from "@tmi/types/api/content-models";
import type { IndustrySector } from "@tmi/types/entities";

const config: DependencySyncConfig<IndustrySectors, IndustrySectorApiResponse, IndustrySector> = {
    name: 'industry-sector',
    store: () => industrySectors,
    syncKey: industrySectorsSyncKey,
    throttle: { hours: 4 },
    queryId: 'cfd9c68bb520360820fcbb3987f963ce',
    pageSize: 100,
    extractPayload: ( response: ApiFetchResponse<IndustrySectors> ) => response?.data?.industrySectorCatalog?.industry_sectors,
    mapItem: ( is: IndustrySectorApiResponse ): IndustrySector => ( {
        id: is.id,
        name: is.name,
        slug: is.slug,
        symbol: is.short_name,
        sectorIds: [ ...( is.assoc_sector_ids ? is.assoc_sector_ids : [] ) ]
    } )
};

export async function refreshIndustrySectorsFromServer(): Promise<IndustrySector[]> {
    return fetchFromServer( config );
}

export async function loadIndustrySectorMap( industrySectorsMap: Map<string, IndustrySector> ): Promise<boolean> {
    return syncDependency( config, industrySectorsMap );
}
